import React from 'react';
import { FormFieldData } from 'components/UserForm';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { TextField, TextFieldProps } from '@mui/material';
import { DateTime } from 'luxon';

interface DateFieldProps {
  readonly fieldItem: FormFieldData;
}

const DateField: React.FC<DateFieldProps> = ({ fieldItem }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale="en">
      <DatePicker
        disableFuture
        label={fieldItem.label}
        openTo="year"
        inputFormat="MM/dd/yyyy"
        views={['year', 'month', 'day']}
        value={fieldItem.dateValue}
        onChange={newValue => {
          fieldItem.onDateChange?.(newValue || null);
        }}
        disabled={fieldItem.isDisabled}
        renderInput={(params: TextFieldProps) => {
          const { inputProps, ...other } = params;
          return (
            <TextField
              fullWidth
              required={fieldItem.isRequired}
              error={fieldItem.isError}
              helperText={fieldItem.errorText}
              variant="standard"
              {...other}
              placeholder={inputProps?.placeholder || 'mm/dd/yyyy'}
              value={inputProps?.value}
              onChange={event => {
                inputProps?.onChange?.(event);
                const value = event.target.value.trim();
                const formats = ['yyyy-MM-dd', 'MM-dd-yyyy', 'MM/dd/yyyy'];
                for (const format of formats) {
                  const parsed = DateTime.fromFormat(value, format);
                  if (parsed.isValid && parsed.toFormat(format) === value) {
                    fieldItem.onDateChange?.(parsed);
                    break;
                  }
                }
              }}
            />
          );
        }}
      />
    </LocalizationProvider>
  );
};
export default DateField;
